import { Vector3 } from 'three';

export const CAMERA_INITIAL_POSITION = new Vector3(-10, 3.75, 16.25);
export const VIEWER_INITIAL_TARGET: [number, number, number] = [0, 1, 0];

export const TRANSITION_DURATION = 1.5;
